export enum ModalTypes {
    AddAttribute = "AddAttribute",
    AddAttributeLabel = "AddAttributeLabel",
    AddBackupService = "AddBackupService",
    AddIdentityProvider = "AddIdentityProvider",
    AddLandingPage = "AddLandingPage",
    AddMessagingTemplate = "AddMessagingTemplate",
    AddMessagingTemplateLanguage = "AddMessagingTemplateLanguage",
    AddOrganization = "AddOrganization",
    AddOrganizationUser = "AddOrganizationUser",
    AddPolicyComponent = "AddPolicyComponent",
    AddProperty = "AddProperty",
    AddRelyingParty = "AddRelyingParty",
    AddRelyingPartyRole = "AddRelyingPartyRole",
    AddRule = "AddRule",
    AddSecurityRule = "AddSecurityRule",
    AddServiceOffering = "AddServiceOffering",
    AddServiceTemplate = "AddServiceTemplate",
    AddVerificationService = "AddVerificationService",
    AddBasicVerificationWorkflowAtApiKeyLevel = "AddBasicVerificationWorkflowAtApiKeyLevel",
    AddVerificationWorkflow = "AddVerificationWorkflow",
    AddWorkflowTemplate = "AddWorkflowTemplate",
    ApproveIdentityProviderChangeRequest = "ApproveIdentityProviderChangeRequest",
    ApproveVerificationServiceChangeRequest = "ApproveVerificationServiceChangeRequest",
    ArchiveOrganization = "ArchiveOrganization",
    ArchiveRelyingParty = "ArchiveRelyingParty",
    ArchiveVerificationService = "ArchiveVerificationService",
    ArchiveWorkflow = "ArchiveWorkflow",
    CancelIdentityProviderChangeRequest = "CancelIdentityProviderChangeRequest",
    CancelVerificationServiceChangeRequest = "CancelVerificationServiceChangeRequest",
    CancelWorkflowChangeRequest = "CancelWorkflowChangeRequest",
    ConfirmAddBackupService = "ConfirmAddBackupService",
    CopyLink = "CopyLink",
    CopyLinkResult = "CopyLinkResult",
    CreateIdentityProviderChangeRequest = "CreateIdentityProviderChangeRequest",
    CreateVerificationServiceChangeRequest = "CreateVerificationServiceChangeRequest",
    CreateWorkflowChangeRequest = "CreateWorkflowChangeRequest",
    DeleteOrganization = "DeleteOrganization",
    DeleteVerificationService = "DeleteVerificationService",
    DeleteWorkflow = "DeleteWorkflow",
    DeleteRelyingParty = "DeleteRelyingParty",
    DeployNowIdentityProviderChangeRequest = "DeployNowIdentityProviderChangeRequest",
    DeployNowVerificationServiceChangeRequest = "DeployNowVerificationServiceChangeRequest",
    DeployNowWorkflowChangeRequest = "DeployNowWorkflowChangeRequest",
    DiscardIdentityProviderChanges = "DiscardIdentityProviderChanges",
    DiscardMessagingTemplateChanges = "DiscardMessagingTemplateChanges",
    DiscardOrganizationDetailsChanges = "DiscardOrganizationDetailsChanges",
    DiscardOrganizationUserDetailsChanges = "DiscardOrganizationUserDetailsChanges",
    DiscardPolicyComponentChanges = "DiscardPolicyComponentChanges",
    DiscardRelyingPartyChanges = "DiscardRelyingPartyChanges",
    DiscardServiceTemplateChanges = "DiscardServiceTemplateChanges",
    DiscardVerificationServiceChanges = "DiscardVerificationServiceChanges",
    DiscardWorkflowChanges = "DiscardWorkflowChanges",
    DiscardWorkflowTemplateChanges = "DiscardWorkflowTemplateChanges",
    EditAttributeLabel = "EditAttributeLabel",
    EditSecurityRule = "EditSecurityRule",
    Error = "Error",
    ExportWorkflow = "ExportWorkflow",
    Loading = "Loading",
    ModifyLandingPageName = "ModifyLandingPageName",
    RejectIdentityProviderChangeRequest = "RejectIdentityProviderChangeRequest",
    RejectVerificationServiceChangeRequest = "RejectVerificationServiceChangeRequest",
    RestoreOrganization = "RestoreOrganization",
    RestoreVerificationService = "RestoreVerificationService",
    RestoreRelyingParty = "RestoreRelyingParty",
    RestoreWorkflow = "RestoreWorkflow",
    SendEmailWithLink = "SendEmailWithLink",
    SendEmailWithLinkResult = "SendEmailWithLinkResult",
    SessionTimeoutWarning = "SessionTimeoutWarning",
    SubmitIdentityProviderChangeRequest = "SubmitIdentityProviderChangeRequest",
    SubmitVerificationServiceChangeRequest = "SubmitVerificationServiceChangeRequest",
    TryNow = "TryNow",
    TryNowResult = "TryNowResult",
    UnsubmitIdentityProviderChangeRequest = "UnsubmitIdentityProviderChangeRequest",
    UnsubmitVerificationServiceChangeRequest = "UnsubmitVerificationServiceChangeRequest",
    UpdateTemplateJSON = "UpdateTemplateJSON",
    UpdateAxnAdminUsersCredentials = "UpdateAxnAdminUsersCredentials",
    ViewPolicyDetails = "ViewPolicyDetails",
    VerificationTransactionDetailsScores = "VerificationTransactionDetailsScores",
    WorkflowServiceDetails = "WorkflowServiceDetails",
    WorkflowServicePolicyDecisionDetails = "WorkflowServicePolicyDecisionDetails",
    CONFIRM = "Dynamic Confirm Modal",
    UpdateOrganizationUserStatus = "Update Organization User Status",
    AddEmailTemplate = "AddEmailTemplate",
    AddEmailTemplateLanguage = "AddEmailTemplateLanguage",
    DiscardEmailTemplateChanges = "DiscardEmailTemplateChanges",

}